<template>
  <div>
    <!-- 客服面板 -->
    <transition name="slide-up">
      <div v-show="isVisible" class="customer-service-panel">
        <div class="customer-service-header">
          <span class="customer-service-title">在线客服</span>
          <i class="el-icon-close close-btn" @click="togglePanel"></i>
        </div>
        <div class="customer-service-content">
          <iframe
            ref="serviceIframe"
            :src="customerServiceUrl"
            frameborder="0"
            class="customer-service-iframe"
            allow="microphone; camera"
          ></iframe>
        </div>
      </div>
    </transition>

    <!-- 客服图标 -->
    <div class="customer-service-icon" @click="togglePanel">
      <i :class="isVisible ? 'el-icon-close' : 'el-icon-chat-dot-round'"></i>
      <span class="customer-service-text">{{ isVisible ? '关闭' : '客服' }}</span>
      <!-- 未读数徽章 -->
      <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerServiceIcon",
  data() {
    return {
      customerServiceUrl: "/im/",
      isVisible: false, // 控制面板显示/隐藏
      unreadCount: 0 // 未读消息数
    };
  },
  computed: {
    customerServiceOrigin() {
      return new URL(this.customerServiceUrl, window.location.origin).origin;
    }
  },
  mounted() {
    // 接收iframe的Token请求和未读数
    window.addEventListener("message", this.handleMessage);
    // 监听发起聊天事件
    this.$root.$on('startChat', this.startChat);
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener("message", this.handleMessage);
    this.$root.$off('startChat', this.startChat);
  },
  methods: {
    togglePanel() {
      this.isVisible = !this.isVisible;
    },
    // 接收iframe的未读数
    handleMessage(e) {
      if (e.origin !== this.customerServiceOrigin) return;

      // 处理未读数更新
      if (e.data && e.data.type === "UNREAD_COUNT") {
        const count = parseInt(e.data.unreadCount, 10) || 0;
        this.unreadCount = count;
      }
    },
    // 发起聊天 - 通过iframe发送消息
    startChat(orderNo) {
      // 先打开面板
      if (!this.isVisible) {
        this.isVisible = true;
      }
      // 等待iframe加载后发送消息
      this.$nextTick(() => {
        const iframe = this.$refs.serviceIframe;
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            { type: "START_CHAT", orderNo: orderNo },
            this.customerServiceOrigin
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 客服面板
.customer-service-panel {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  max-width: 1400px;
  max-height: 900px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  z-index: 10000;
  overflow: hidden;

  .customer-service-header {
    height: 50px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    color: #ffffff;

    .customer-service-title {
      font-size: 16px;
      font-weight: 500;
    }

    .close-btn {
      font-size: 20px;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: rotate(90deg);
      }
    }
  }

  .customer-service-content {
    flex: 1;
    overflow: hidden;
    background: #ffffff;

    .customer-service-iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}

// 客服图标
.customer-service-icon {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 10001;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: scale(0.95);
  }

  i {
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 2px;
  }

  .customer-service-text {
    font-size: 12px;
    color: #ffffff;
    font-weight: 500;
  }

  // 未读数徽章
  .unread-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    background: #ff4757;
    color: #ffffff;
    font-size: 11px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
    border-radius: 9px;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
    z-index: 10002;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 动画效果
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.95);
}
</style>
